import { useTranslation } from 'react-i18next';
import BaseButton from 'components/atoms/baseButton';
import { convertSecondsToTime } from 'utils/timeHelper';
import { ModuleType } from 'infrastructure/enums';
import PlayCallRecord from 'components/molecules/play-call-record';
import {
  getCallTypeLabel,
  type ICallHistory,
} from 'infrastructure/hooks/callHistoryManagement/types';

import type { TableProps } from 'antd';

export const useColumns = ({
  setEditingItem,
}: {
  setEditingItem: (editingItem: ICallHistory) => void;
}): TableProps<ICallHistory>['columns'] => {
  const { t } = useTranslation();

  return [
    {
      title: t('labels.patientName'),
      width: '10%',
      render: (_, record) => (
        <>
          <div>{record.patient.name}</div>
        </>
      ),
    },
    {
      title: t('labels.patientGuid'),
      width: '15%',
      render: (_, record) => (
        <>
          <div>{record.patient.guid}</div>
        </>
      ),
    },
    {
      title: t('labels.phone'),
      width: '5%',
      render: (_, record) => (
        <>
          <div>{record.patient.phone}</div>
        </>
      ),
    },
    {
      title: t('labels.callId'),
      width: '15%',
      render: (_, record) => (
        <>
          <div>{record.callId}</div>
        </>
      ),
    },
    {
      title: t('labels.platform'),
      width: '10%',
      render: (_, record) => (
        <>
          <div>{getCallTypeLabel(record.type)}</div>
        </>
      ),
    },
    {
      title: t('labels.callDuration'),
      width: '5%',
      render: (_, record) => (
        <>
          <div>{convertSecondsToTime(record.duration)}</div>
        </>
      ),
    },
    {
      title: t('labels.agent'),
      width: '10%',
      render: (_, record) => (
        <>
          <div>{record.agent}</div>
        </>
      ),
    },
    {
      title: t('labels.callRecord'),
      width: '10%',
      render: (_, record) => (
        <PlayCallRecord
          patientPhone={record.patient.phone}
          patientName={record.patient.name}
          callId={record.callId}
          patientGuid={record.patient.guid}
          module={
            record.type === 'patient-call' ? ModuleType.RPM : ModuleType.CCM
          }
        />
      ),
    },
    {
      title: t('labels.action'),
      width: '1%',
      render: (_, record) => (
        <BaseButton
          label={t('labels.manage')}
          disabled={record.duration === 0}
          onClick={() => {
            setEditingItem(record);
          }}
        />
      ),
    },
  ];
};
